import React, { FC, ReactElement } from 'react';
import '../OfferContactInformation/ContactInformationHeader.scss';
import withLocalization from '../hoc/withLocalization';

const ConfirmationHeader: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  return (
    <>
      <div className="dateHeaderWrapper">
        <h3 className="headBaskerville">
          {localize('preview-sales-engine.static-content.copy.Confirmation Page.header')}
        </h3>
      </div>
    </>
  );
};
export default withLocalization(ConfirmationHeader);
